const joinWithSymbol = <T extends unknown[]>(arr: T, symbol: string) => arr.join(` ${symbol} `);

export { joinWithSymbol };
